import { render, staticRenderFns } from "./merchant-list.vue?vue&type=template&id=7a81da2b&"
import script from "./merchant-list.vue?vue&type=script&lang=js&"
export * from "./merchant-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports